import { render, staticRenderFns } from "./ClaimSwayOfferSection.vue?vue&type=template&id=f4ee3762&scoped=true&"
import script from "./ClaimSwayOfferSection.vue?vue&type=script&lang=js&"
export * from "./ClaimSwayOfferSection.vue?vue&type=script&lang=js&"
import style0 from "./ClaimSwayOfferSection.vue?vue&type=style&index=0&id=f4ee3762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ee3762",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VRow})
